import React, { ReactNode } from 'react';

export interface TableContentProps {
  children?: ReactNode;
}

export const TableContent = ({ children }: TableContentProps) => (
  <>{children}</>
);
